/**
 *
 *  const axios
 *
 *  @author dasheng
 *  @date   2019-7-24
 */
import attendance from "./checkInset.js";

const base = {
  online: "", // 生产环境
  testOnline: "", // 测试环境
  dev: "" // 本地开发环境
};
export default {
  attendance,
  // 登录接口
  login: {
    url: "/user/login",
    method: "post",
    lodingState: true
  },
  //  短信验证1
  verifyCode1: {
    url: "/user/verifycode",
    method: "post",
    lodingState: true
  },
  // 短信验证2
  verifyCode2: {
    url: "/user/resetPassword/verifyCode",
    method: "post",
    lodingState: true
  },
  //  重置密码
  resetPassword: {
    url: "/user/resetPassword",
    method: "post",
    lodingState: true
  },
  // 权限
  privileges: {
    url: "/user/privileges",
    method: "post",
    lodingState: true
  },
  //  短信验证1
  verifyCode1: {
    url: "/user/verifycode",
    method: "post",
    lodingState: true
  },
  // 短信验证2
  verifyCode2: {
    url: "/user/resetPassword/verifyCode",
    method: "post",
    lodingState: true
  },
  //  重置密码
  resetPassword: {
    url: "/user/resetPassword",
    method: "post",
    lodingState: true
  },
  //匹配验证码
  checkVerifyCode: {
    url: "/forgetPassword/checkVerifyCode",
    method: "post",
    lodingState: true
  },
  // 电话验证
  checkMobileRegistered: {
    url: "/user/checkMobileRegistered",
    method: "post",
    lodingState: true
  },
  checkVerifyCode: {
    url: "/register/checkVerifyCode",
    method: "post",
    lodingState: true
  },
  // 获取短信验证码
  registerVerifyCode: {
    url: "/user/verifycode",
    method: "post",
    lodingState: true
  },
  // 提交注册
  register: {
    url: "/user/register",
    method: "post",
    lodingState: true
  },
  // 查询证书借用部门
  listBorrowDepartment: {
    url: "/credential/borrow/listBorrowDepartment",
    method: "post",
    lodingState: true
  },
  // 修改审批结果
  credentialUpdate: {
    url: "/approve/credential/update",
    method: "post",
    lodingState: true
  },
  // 提交审批
  approve: {
    url: "/approve/credential/approve",
    method: "post",
    lodingState: true
  },
  // 修改证书借用状态
  updateStatus: {
    url: "/credential/borrow/updateStatus",
    method: "post",
    lodingState: true
  },
  // 借用记录详情(复查)
  detail: {
    url: "/approve/credential/detail",
    method: "post",
    lodingState: true
  },
  // 下载证书
  batchDownloadFile: {
    url: "credential/borrow/batchDownloadFile",
    method: "post",
    lodingState: true,
    streamFile: true
  },
  // 证书归还
  return: {
    url: "/credential/borrow/",
    urlEnd: "/return",
    method: "post",
    lodingState: true
  },
  // 证书借用审批列表
  getApproveList: {
    url: "/approve/credential/getApproveList",
    method: "post",
    lodingState: true
  },
  // 我的借用列表
  getBorrowList: {
    url: "approve/credential/getBorrowList",
    method: "post",
    lodingState: true
  },
  recoveryFileByFileId: {
    url: "/organization/",
    urlEnd: "/recoveryFileByFileId",
    method: "post",
    lodingState: true
  },
  // 查询审批信息
  queryApproveByUserId: {
    url: "/approve/queryApproveByUserId",
    method: "post",
    lodingState: true
  },
  // 文件描述查询
  select: {
    url: "/project/",
    urlEnd: "/select",
    method: "post",
    lodingState: true
  },
  //查询用户个人签章开通状态
  msspId: {
    url: "/sign/msspId",
    method: "post",
    lodingState: true
  },
  //查询用户开通企业签章状态
  signMsspId: {
    url: "/enter/sign/msspId",
    method: "post",
    lodingState: true
  },
  // 重新提交审批
  updateApproveByUserId: {
    url: "/approve/updateApproveByUserId",
    method: "post",
    lodingState: true
  },
  // 进行审批
  processing: {
    url: "approve/processing",
    method: "post",
    lodingState: true
  },
  // 文件重新上传--文件审批
  uploadFile: {
    url: "/approve/uploadFile",
    method: "post",
    lodingState: true
  },
  // 不使用第三方签字，直接提交
  blank: {
    url: "/sign/seal/blank",
    method: "post",
    lodingState: true
  },
  // 发起签章
  seal: {
    url: "/sign/seal",
    method: "post",
    lodingState: true
  },
  // 获取签章结果
  result: {
    url: "/sign/result",
    method: "post",
    lodingState: true
  },
  // 审批列表
  approveGetApproveList: {
    url: "/approve/getApproveList",
    method: "post",
    lodingState: true
  },
  searchMessage: {
    url: "/manager/searchMessage",
    method: "post",
    lodingState: true
  },
  // 项目花名册
  projectRoster: {
    url: "/projectUser/",
    urlEnd: "/projectRoster",
    method: "post",
    lodingState: true
  },
  // 重新上传图片
  updateImgUrl: {
    url: "/approve/updateImgUrl",
    method: "post",
    lodingState: true
  },
  // 我的审批列表
  getWebApproveList: {
    url: "/approve/getWebApproveList",
    method: "post",
    lodingState: true
  },
  // 审批统计列表
  getApproveCountData: {
    url: "/approve/getApproveCountData",
    method: "post",
    lodingState: true
  },
  // 我审批的列表
  webHistory: {
    url: "/approve/webHistory",
    method: "post",
    lodingState: true
  },
  // 历史审批
  queryHistoryPaymentApprove: {
    url: "/approve/payment/queryHistoryPaymentApprove",
    method: "post",
    lodingState: true
  },
  // 资金审批搜索
  queryPaymentApprove: {
    url: "/approve/payment/queryPaymentApprove",
    method: "post",
    lodingState: true
  },
  // 资金审批信息
  queryProjectPaymentApprove: {
    url: "/approve/payment/queryProjectPaymentApprove",
    method: "post",
    lodingState: true
  },
  // 审批
  projectPaymentProcessing: {
    url: "/approve/payment/projectPaymentProcessing",
    method: "post",
    lodingState: true
  },
  // 请款资料
  getProjectPaymentByPaymentId: {
    url: "project/",
    urlEnd: "/projectFund/getProjectPaymentByPaymentId",
    method: "post",
    lodingState: true
  },
  // 查找用户
  companyUser: {
    url: "/query/companyUser",
    method: "post",
    lodingState: true
  },
  // 资金审批重新提交
  resubmitProjectPaymentApproveByApproveId: {
    url: "/approve/payment/resubmitProjectPaymentApproveByApproveId",
    method: "post",
    lodingState: true
  },
  // 审批撤销
  approveBackout: {
    url: "/approve/approveBackout",
    method: "post",
    lodingState: true
  },
  //资金保存上传删除
  uploadFilePaymentByPaymentId: {
    url: "/project/",
    urlEnd: "/projectFund/uploadFilePaymentByPaymentId",
    method: "post",
    lodingState: true
  },
  // 资金审批列表
  paymentApproveList: {
    url: "/approve/payment/paymentApproveList",
    method: "post",
    lodingState: true
  },
  // 质量安全检查警告及整改数
  qualityAndSecurityAmount: {
    url: "/project/statistic/",
    urlEnd: "/qualityAndSecurityAmount",
    method: "post",
    lodingState: true
  },
  // 项目已上传文件数量
  projectFileAmount: {
    url: "/project/statistic/",
    urlEnd: "/projectFileAmount",
    method: "post",
    lodingState: true
  },
  // 按年份统计每月台账
  projectFundCounts: {
    url: "project/",
    urlEnd: "/projectFundCounts",
    method: "post",
    lodingState: true
  },
  // 概览查询
  fundInformation: {
    url: "project/fundInformation/",
    urlEnd: "void",
    method: "post",
    lodingState: true
  },
  // 详细月份资金查询
  lineChart: {
    url: "project/lineChart/",
    urlEnd: "void",
    method: "post",
    lodingState: true
  },
  // 工程款申请列表
  projectPaymentInventoryList: {
    url: "/project/",
    urlEnd: "/projectFund/projectPaymentInventoryList",
    method: "post",
    lodingState: true
  },
  // 申请请款
  applyForFund: {
    url: "project/",
    urlEnd: "/projectFund/applyForFund",
    method: "post",
    lodingState: true
  },
  // 工程款拨付申请
  projectPaymentApplication: {
    url: "/project/",
    urlEnd: "/projectFund/projectPaymentApplication",
    method: "post",
    lodingState: true
  },
  // 修改台账信息
  projectFundUpdate: {
    url: "/project/",
    urlEnd: "/projectFund/update",
    method: "post",
    lodingState: true
  },
  // 删除台账
  projectFundDelete: {
    url: "/project/",
    urlEnd: "/projectFund/delete",
    method: "post",
    lodingState: true
  },
  // 台账列表
  projectFundList: {
    url: "/project/",
    urlEnd: "/projectFundList",
    method: "post",
    lodingState: true
  },
  // 添加台账
  projectFundAdd: {
    url: "/project/",
    urlEnd: "/projectFund/add",
    method: "post",
    lodingState: true
  },
  // 拨付款信息查询
  queryProjectPaymentByPaymentId: {
    url: "/project/",
    urlEnd: "/projectFund/queryProjectPaymentByPaymentId",
    method: "post",
    lodingState: true
  },
  // 确认收款
  confirmProjectPaymentByPaymentId: {
    url: "/project/",
    urlEnd: "/projectFund/confirmProjectPaymentByPaymentId",
    method: "post",
    lodingState: true
  },
  // 发起审批
  initiateApproveByUserId: {
    url: "/approve/initiateApproveByUserId",
    method: "post",
    lodingState: true
  },
  // 文件描述增删图片
  projectUpdate: {
    url: "/project/",
    urlEnd: "/update",
    method: "post",
    lodingState: true
  },
  createNewFolder: {
    url: "/project/",
    urlEnd: "/createNewFolder",
    method: "post",
    lodingState: true
  },
  projectFileAddFolder: {
    url: "/project/",
    urlEnd: "/projectFile/addFolder",
    method: "post",
    lodingState: true
  },
  rename: {
    url: "/project/web/",
    urlEnd: "/rename",
    method: "post",
    lodingState: true
  },
  projectFileDelete: {
    url: "/project/",
    urlEnd: "/projectFile/delete",
    method: "post",
    lodingState: true
  },
  projectFileAddFile: {
    url: "/project/",
    urlEnd: "/projectFile/addFile",
    method: "post",
    lodingState: true
  },
  list: {
    url: "table/list",
    method: "post",
    lodingState: true
  },
  // 批量移动文件
  moveProjectFile: {
    url: "/project/",
    urlEnd: "/moveProjectFile",
    method: "post",
    lodingState: true
  },
  projectFileList: {
    url: "/project/",
    urlEnd: "/projectFileList",
    method: "post",
    lodingState: true
  },
  // 批量删除文件
  deleteFolderByFileId: {
    url: "/project/",
    urlEnd: "/deleteFolderByFileId",
    method: "post",
    lodingState: true
  },
  // 模糊查询模板
  tableSearch: {
    url: "table/search",
    method: "post",
    lodingState: true
  },
  recentlyUpLoaded: {
    url: "/project/",
    urlEnd: "/recentlyUpLoaded",
    method: "post",
    lodingState: true
  },
  // 项目信息修改web端
  baseInfoUpdateWeb: {
    url: "/project/",
    urlEnd: "/baseInfo/updateWeb",
    method: "post",
    lodingState: true
  },
  // 项目信息查看
  queryProject: {
    url: "/project/",
    urlEnd: "/queryProject",
    method: "post",
    lodingState: true
  },
  // 项目信息编辑权限查询
  checkProjectInfoPrivilege: {
    url: "/project/",
    urlEnd: "/checkProjectInfoPrivilege",
    method: "post",
    lodingState: true
  },
  // 获取登录人角色类别
  checkUserCompanyRoleType: {
    url: "/projectUser/",
    urlEnd: "/checkUserCompanyRoleType",
    method: "post",
    lodingState: true
  },
  //项目详情
  laborQueryProject: {
    url: "/labor/queryProject",
    method: "post",
    lodingState: true
  },
  // 人员管理初始化页面
  companyRole: {
    url: "project/",
    urlEnd: "/companyRole",
    method: "post",
    lodingState: true
  },
  // 历史项目资料查询
  queryProjectHistory: {
    url: "/projectSources/queryProject/history",
    method: "post",
    lodingState: true
  },
  // 检查登录人对项目操作权限
  checkUserPrivileges: {
    url: "projectUser/",
    urlEnd: "/checkUserPrivileges",
    method: "post",
    lodingState: true
  },
  // 下载行政区划
  regionDownload: {
    url: "/version/region/download",
    method: "post",
    lodingState: true
  },
  // 添加项目
  projectAdd: {
    url: "project/add",
    method: "post",
    lodingState: true
  },
  // 在建项目资料查询
  queryProjectBuild: {
    url: "/projectSources/queryProject/build",
    method: "post",
    lodingState: true
  },
  // 查询项目中的劳务单位
  companies: {
    url: "/labor/companies",
    method: "post",
    lodingState: true
  },
  // 查询添加的企业
  projectUserByCompanyName: {
    url: "/projectUser/",
    urlEnd: "/selectCompanyByCompanyName",
    method: "post",
    lodingState: true
  },
  // 最外层项目人员管理信息
  selectTopJobList: {
    url: "projectUser/",
    urlEnd: "/selectTopJobList",
    method: "post",
    lodingState: true
  },
  webUserLeft: {
    url: "projectUser/",
    urlEnd: "/webUserLeft",
    method: "post",
    lodingState: true
  },
  // 第二層及以後的項目人員
  selectSecondaryJob: {
    url: "projectUser/",
    urlEnd: "/selectSecondaryJob",
    method: "post",
    lodingState: true
  },
  // 各单位角色模糊查询人员
  selectInProjectUserByLike: {
    url: "/projectUser/",
    urlEnd: "/selectInProjectUserByLike",
    method: "post",
    lodingState: true
  },
  addUsersToProject: {
    url: "/projectUser/",
    urlEnd: "/addUsersToProject",
    method: "post",
    lodingState: true
  },
  // 添加质量检查类型
  addProjectQualityTypeByProjectId: {
    url: "/projectQualityCheck/",
    urlEnd: "/addProjectQualityTypeByProjectId",
    method: "post",
    lodingState: true
  },
  // 项目质量信息查看
  projectQualityInfoByQualityId: {
    url: "/projectQualityCheck/",
    urlEnd: "/projectQualityInfoByQualityId",
    method: "post",
    lodingState: true
  },
  // 删除自定义检查类型
  deleteProjectQualityType: {
    url: "/projectQualityCheck/",
    urlEnd: "/deleteProjectQualityType",
    method: "post",
    lodingState: true
  },
  // 项目质量检查列表
  projectQualityList: {
    url: "/projectQualityCheck/",
    urlEnd: "/projectQualityList",
    method: "post",
    lodingState: true
  },
  saveProjectQuality: {
    url: "/projectQualityCheck/",
    urlEnd: "/saveProjectQuality",
    method: "post",
    lodingState: true
  },
  // 编辑未完结质量检查
  updateQualityCheck: {
    url: "/projectQualityCheck/",
    urlEnd: "/updateQualityCheck",
    method: "post",
    lodingState: true
  },
  // 保存项目质量检查信息
  projectQualityCheckSaveProjectQuality: {
    url: "/projectQualityCheck/saveProjectQuality",
    method: "post",
    lodingState: true
  },
  deleteUsertoCompany: {
    url: "/manager/",
    urlEnd: "/deleteUsertoCompany",
    method: "post",
    lodingState: true
  },
  // 质量检查类型列表
  getProjectQualityType: {
    url: "/projectQualityCheck/",
    urlEnd: "/getProjectQualityType",
    method: "post",
    lodingState: true
  },
  // 项目质量检查数据统计
  countProjectQuality: {
    url: "/projectQualityCheck/",
    urlEnd: "/countProjectQuality",
    method: "post",
    lodingState: true
  },
  // 发起新质量检查
  launchQualityCheck: {
    url: "/projectQualityCheck/",
    urlEnd: "/launchQualityCheck",
    method: "post",
    lodingState: true
  },
  // 添加检查复核申请
  addCheckReviewResult: {
    url: "/checkResult/addCheckReviewResult",
    method: "post",
    lodingState: true
  },
  // 提交复核结果
  updateCheckResult: {
    url: "/checkResult/updateCheckResult",
    method: "post",
    lodingState: true
  },
  // 安全检查类型添加
  addProjectSecurityType: {
    url: "/projectSecurityCheck/",
    urlEnd: "/addProjectSecurityType",
    method: "post",
    lodingState: true
  },
  // 查询安全检查信息
  selectSecurityCheck: {
    url: "/projectSecurityCheck/",
    urlEnd: "/selectSecurityCheck",
    method: "post",
    lodingState: true
  },
  // 安全检查类型删除
  deleteProjectSecurityType: {
    url: "/projectSecurityCheck/",
    urlEnd: "/deleteProjectSecurityType",
    method: "post",
    lodingState: true
  },
  // 查看安全检查文件列表
  securityCheckList: {
    url: "/projectSecurityCheck/",
    urlEnd: "/securityCheckList",
    method: "post",
    lodingState: true
  },
  // 保存安全检查信息
  saveSecurityCheck: {
    url: "/projectSecurityCheck/",
    urlEnd: "/saveSecurityCheck",
    method: "post",
    lodingState: true
  },
  // 修改人员
  insertProjectsecurity: {
    url: "/manager/insertProjectsecurity",
    method: "post",
    lodingState: true
  },
  // 安全检查类型查询
  selectSecurityType: {
    url: "/projectSecurityCheck/",
    urlEnd: "/selectSecurityType",
    method: "post",
    lodingState: true
  },
  // 安全检查统计
  statisticalFigureData: {
    url: "/projectSecurityCheck/",
    urlEnd: "/statisticalFigureData",
    method: "post",
    lodingState: true
  },
  // 发起检查--待检查
  projectSecurityToCheck: {
    url: "/projectSecurityCheck/",
    urlEnd: "/projectSecurityToCheck",
    method: "post",
    lodingState: true
  },
  // 查询监控设备信息列表
  monitorList: {
    url: "/monitor/list",
    method: "post",
    lodingState: true
  },
  // 新增监控设备信息
  monitorSave: {
    url: "/monitor/save",
    method: "post",
    lodingState: true
  },
  // 删除监控设备
  monitorDelete: {
    url: "/monitor/delete",
    method: "post",
    lodingState: true
  },
  OptionedFileProjectList: {
    url: "/organization/OptionedFileProjectList",
    method: "post",
    lodingState: true
  },
  projectFileLogs: {
    url: "/organization/",
    urlEnd: "/projectFileLogs",
    method: "post",
    lodingState: true
  },
  // 施工日志项目列表
  getConstructionProjects: {
    url: "/constructionLog/getConstructionProjects",
    method: "post",
    lodingState: true
  },
  statistic: {
    url: "/supervision/statistic",
    method: "post",
    lodingState: true
  },
  // 选择当前企业
  currentCompany: {
    url: "/company/choose/current/company",
    method: "post",
    lodingState: true
  },
  changeSort: {
    url: "/user/changeSort",
    method: "post",
    lodingState: true
  },
  // 获取功能菜单列表数据
  userMenu: {
    url: "/user/menu",
    method: "post",
    lodingState: true
  },
  // 统计项目
  projectStat: {
    url: "/project/stat",
    method: "post",
    lodingState: true
  },
  // 修改个人信息
  userUpdate: {
    url: "/user/update",
    method: "post",
    lodingState: true
  },
  // 个人中心
  userDetail: {
    url: "/user/detail",
    method: "post",
    lodingState: true
  },
  // 是否有未读消息
  messageUnread: {
    url: "/message/unread",
    method: "post",
    lodingState: true
  },
  // 待办事项列表数据统计
  toDoListSeparateNum: {
    url: "/approve/toDoListSeparateNum",
    method: "post",
    lodingState: true
  },
  // 退出登录
  logout: {
    url: "/user/logout",
    method: "post",
    lodingState: true
  },
  // 查询当前企业
  userCompanys: {
    url: "/company/query/user/companys",
    method: "post",
    lodingState: true
  },
  // 文件上传
  avatarImgFile: {
    url: "user/upload/avatarImgFile",
    method: "post",
    lodingState: true
  },
  // 概览查询
  investAmount: {
    url: "/manager/project/statistic/region/project/invest/amount",
    method: "post",
    lodingState: true
  },
  // 凉山州工程项目数量统计
  regionProjectCount: {
    url: "/manager/project/statistic/region/project/count",
    method: "post",
    lodingState: true
  },
  // 凉山州工程项目类型统计
  typeCount: {
    url: "manager/project/statistic/region/project/type/count",
    method: "post",
    lodingState: true
  },
  checkCount: {
    url: "/manager/project/statistic/region/project/check/count",
    method: "post",
    lodingState: true
  },
  // 申请创建企业
  companyCreate: {
    url: "/company/create",
    method: "post",
    lodingState: true
  },
  // 提交反馈
  feedbackSubmit: {
    url: "/user/feedback/submit",
    method: "post",
    lodingState: true
  },
  // 根据企业条件查询企业列表
  companyCondition: {
    url: "/query/company/condition",
    method: "post",
    lodingState: true
  },
  // 申请加入企业
  companyJoin: {
    url: "/company/join",
    method: "post",
    lodingState: true
  },
  // 历史审批列表
  queryHistoryPaymentApproveList: {
    url: "/approve/payment/queryHistoryPaymentApproveList",
    method: "post",
    lodingState: true
  },
  // 标记为已读
  markRead: {
    url: "/message/mark/read",
    method: "post",
    lodingState: true
  },
  messageDelete: {
    url: "/message/delete",
    method: "post",
    lodingState: true
  },
  // 加星标注操作
  addStarByMessageId: {
    url: "/addStarMessage/addStarByMessageId",
    method: "post",
    lodingState: true
  },
  // 取消加星标注
  cancelStarByMessageId: {
    url: "/addStarMessage/cancelStarByMessageId",
    method: "post",
    lodingState: true
  },
  // 通知
  messageAdvice: {
    url: "/message/advice",
    method: "post",
    lodingState: true
  },
  // 私信
  personalLetter: {
    url: "/message/personal/letter",
    method: "post",
    lodingState: true
  },
  // 加星标注列表
  addStarMessageListApp: {
    url: "/addStarMessage/addStarMessageListApp",
    method: "post",
    lodingState: true
  },
  // 地址获取
  getProvices: {
    url: "/manager/getProvices",
    method: "post",
    lodingState: true
  },
  // 获取城市
  getCitys: {
    url: "/manager/getCitys",
    method: "post",
    lodingState: true
  },
  // 获取国家
  getCountys: {
    url: "/manager/getCountys",
    method: "post",
    lodingState: true
  },
  // 导出excel
  depositId: {
    url: "/deposit/excel/depositId",
    method: "post",
    lodingState: true
  },
  // 个人印章
  signImage: {
    url: "/sign/image",
    method: "post",
    lodingState: true
  },
  // 查询当前人员企业印章
  signLibrary: {
    url: "enter/sign/library",
    method: "post",
    lodingState: true
  },
  // 修改或删除签章
  taskUpdateOrDelete: {
    url: "/enter/sign/task/updateOrDelete",
    method: "post",
    lodingState: true
  },
  // 保存企业签章
  signTask: {
    url: "/enter/sign/task",
    method: "post",
    lodingState: true
  },
  // 获取模板表单
  tableData: {
    url: "/table/data/",
    urlEnd: "void",
    method: "post",
    lodingState: true
  },
  // 修改表格数据
  tableUpdate: {
    url: "table/",
    urlEnd: "/data/update",
    method: "post",
    lodingState: true
  },
  // 保存表格
  tableSave: {
    url: "table/",
    urlEnd: "/data/save",
    method: "post",
    lodingState: true
  },
  // 获取文件表单
  tableWeb: {
    url: "/table/",
    urlEnd: "/data/web",
    method: "post",
    lodingState: true
  },
  projectSelect: {
    url: "/project/",
    urlEnd: "/select",
    method: "post",
    lodingState: true
  },
  // 示例
  update11: {
    url: "/credential/borrow/updateStatus",
    urlEnd: "/update",
    method: "post",
    lodingState: true
  },
  //匹配验证码
  checkVerifyCode: {
    url: "/forgetPassword/checkVerifyCode",
    method: "post",
    lodingState: true
  },
  // 电话验证
  checkMobileRegistered: {
    url: "/user/checkMobileRegistered",
    method: "post",
    lodingState: true
  },
  update: {
    url: "/user/custom/project/",
    urlEnd: "/update",
    method: "post",
    lodingState: true
  },
  //匹配验证码
  checkVerifyCode: {
    url: "/forgetPassword/checkVerifyCode",
    method: "post",
    lodingState: true
  },
  // 电话验证
  checkMobileRegistered: {
    url: "/user/checkMobileRegistered",
    method: "post",
    lodingState: true
  },
  update: {
    url: "/user/custom/project/",
    urlEnd: "/update",
    method: "post",
    lodingState: true
  },
  // 项目人员花名册
  queryProjectUserRoster: {
    url: "roster/",
    urlEnd: "/queryProjectUserRoster",
    method: "post",
    lodingState: true
  },
  // 企业人员花名册
  queryCompanyUserRoster: {
    url: "/roster/queryCompanyUserRoster",
    method: "post",
    lodingState: true
  },
  // 企业项目人员花名册
  queryCompanyProjectUserRoster: {
    url: "/roster/",
    urlEnd: "/queryCompanyProjectUserRoster",
    method: "post",
    lodingState: true
  },
  // 人员管理
  userRoster: {
    url: "/roster/userRoster",
    method: "post",
    lodingState: true
  },
  // 入企申请
  applyCompanyList: {
    url: "/organization/apply/company/list",
    method: "post",
    lodingState: true
  },
  // 组织架构树
  departmentTree: {
    url: "/organization/department/tree",
    method: "post",
    lodingState: true
  },
  // 查看部门部门人员和部门职位
  departmentTree2: {
    url: "/organization/data/department/",
    urlEnd: "void",
    method: "post",
    lodingState: true
  },
  // 申请加入企业
  joinCompany: {
    url: "/organization/join/company",
    method: "post",
    lodingState: true
  },
  // 模糊查询人员
  subcontractWorkersSelect: {
    url: "/project/subcontractWorkers/select",
    method: "post",
    lodingState: true
  },
  // 企业名片
  companyCard: {
    url: "/query/company/card",
    method: "post",
    lodingState: true
  },
  // 企业风采图片截取
  companyStyle: {
    url: "/company/companyStyle",
    method: "post",
    lodingState: true
  },
  // 企业名片的编辑保存接口
  updateCompanyMessage: {
    url: "/company/updateCompanyMessage",
    method: "post",
    lodingState: true
  },
  // 删除企业图片
  deleteCompanyImg: {
    url: "/company/",
    urlEnd: "/deleteCompanyImg",
    method: "post",
    lodingState: true
  },
  // 证书借用
  borrowDepartment: {
    url: "/credential/borrow/department/",
    urlEnd: "void",
    method: "post",
    lodingState: true
  },
  // 12.30.修改证书借用信息-重新提交
  borrowUpdate: {
    url: "/credential/borrow/update",
    method: "post",
    lodingState: true
  },
  // 1.1.3.证书借用
  borrowSave: {
    url: "/credential/borrow/save",
    method: "post",
    lodingState: true
  },
  // 12.29.删除-借用申请
  borrowDelete: {
    url: "/credential/borrow/delete",
    method: "post",
    lodingState: true
  },
  // 证书分类
  companyStatisticalHistogram: {
    url: "/company/companyStatisticalHistogram",
    method: "post",
    lodingState: true
  },
  // 1.2.3.证书统计-柱状图-人员
  personStatisticalHistogram: {
    url: "/company/personStatisticalHistogram",
    method: "post",
    lodingState: true
  },
  // 1.2.1.证书统计-饼状图
  statisticalGraph: {
    url: "/company/statisticalGraph",
    method: "post",
    lodingState: true
  },
  // 企业证书详情
  companyCredentialMessage: {
    url: "company/companyCredentialMessage",
    method: "post",
    lodingState: true
  },
  // 2.1.25.获取个人证书详情
  getPersonCredentialMessage: {
    url: "/person/getPersonCredentialMessage",
    method: "post",
    lodingState: true
  },
  // 2.1.11.新增/修改企业证书类型
  addOrUpdateCompanyCredentialTypes: {
    url: "company/addOrUpdateCompanyCredentialTypes",
    method: "post",
    lodingState: true
  },
  // 2.1.13.新增/修改企业证书存放地址
  addOrUpdateCredentialPlaces: {
    url: "company/addOrUpdateCredentialPlaces",
    method: "post",
    lodingState: true
  },
  deletePersonCredentialType: {
    url: "person/deletePersonCredentialType",
    method: "post",
    lodingState: true
  },
  // 2.1.23.删除个人证书
  deletePersonCredential: {
    url: "person/deletePersonCredential",
    method: "post",
    lodingState: true
  },
  // 2.1.10.获取企业证书类型列表
  companyCredentialTypes: {
    url: "company/companyCredentialTypes",
    method: "post",
    lodingState: true
  },
  // 2.1.12.获取企业证书存放地址列表
  getCredentialPlaces: {
    url: "company/getCredentialPlaces",
    method: "post",
    lodingState: true
  },
  // 2.1.26.获取个人证书类型第一等级列表
  personCredentialFirstLevel: {
    url: "/person/personCredentialFirstLevel",
    method: "post",
    lodingState: true
  },
  // 2.1.21.修改个人证书信息
  updatePersonCredential: {
    url: "/person/updatePersonCredential",
    method: "post",
    lodingState: true
  },
  // 2.1.20.新增人员证书
  addPersonCredential: {
    url: "/person/addPersonCredential",
    method: "post",
    lodingState: true
  },
  // 2.1.19.删除企业证书类型
  deleteCompanyCredentialType: {
    url: "company/deleteCompanyCredentialType",
    method: "post",
    lodingState: true
  },
  // 2.1.17.删除企业证书
  deleteCompanyCredential: {
    url: "company/deleteCompanyCredential",
    method: "post",
    lodingState: true
  },
  // 2.1.18.删除企业证书存放地址
  deleteCredentialPlace: {
    url: "company/deleteCredentialPlace",
    method: "post",
    lodingState: true
  },
  // 2.1.14.获取企业证书列表
  companyCredentialList: {
    url: "company/companyCredentialList",
    method: "post",
    lodingState: true
  },
  // 2.1.14.获取人员证书列表
  personCredentialList: {
    url: "/person/personCredentialList",
    method: "post",
    lodingState: true
  },
  // 1.1.1.证书借用列表
  credentialBorrow: {
    url: "/credential/borrow",
    method: "post",
    lodingState: true
  },
  // 12.34.查询证书借用部门
  listBorrowDepartment: {
    url: "credential/borrow/listBorrowDepartment",
    method: "post",
    lodingState: true
  },
  // 企业证件
  saveOrUpdate: {
    url: "/companyRefQualificationLevel/saveOrUpdate",
    method: "post",
    lodingState: true
  },
  companyRefQualificationLevel: {
    url: "/companyRefQualificationLevel/",
    urlEnd: "void",
    method: "post",
    lodingState: true
  },
  companyRefQualificationLevelDelete: {
    url: "/companyRefQualificationLevel/",
    urlEnd: "/delete",
    method: "post",
    lodingState: true
  },
  // 借出归还
  bookOperationBorrow: {
    url: "/bookOperation/borrow",
    method: "post",
    lodingState: true
  },
  bookOperationReturn: {
    url: "/bookOperation/",
    urlEnd: "/return",
    method: "post",
    lodingState: true
  },
  bookOperationBorrowList: {
    url: "/bookOperation/borrowList",
    method: "post",
    lodingState: true
  },
  userRefCertificateLevel: {
    url: "/userRefCertificateLevel",
    method: "post",
    lodingState: true
  },
  // 人员资质
  userRefCertificateLevelSaveOrUpdate: {
    url: "/userRefCertificateLevel/saveOrUpdate",
    method: "post",
    lodingState: true
  },
  userRefCertificateLevel2: {
    url: "/userRefCertificateLevel",
    urlEnd: "void",
    method: "post",
    lodingState: true
  },
  userRefCertificateLevelDelete: {
    url: "/userRefCertificateLevel",
    urlEnd: "/delete",
    method: "post",
    lodingState: true
  },
  // 1.5.查找用户
  queryCompanyUser: {
    url: "/query/companyUser",
    method: "post",
    lodingState: true
  },
  // 1.8.46.未绑定角色单位添加人员
  addProjectRefUserToUnboundCompany: {
    url: "/project/",
    urlEnd: "/addProjectRefUserToUnboundCompany",
    method: "post",
    lodingState: true
  },
  // 17.8.调整个人部门,个人部门职位
  organizationAdjust: {
    url: "/organization/",
    urlEnd: "/adjust",
    method: "post",
    lodingState: true
  },
  // 17.4.查看部门权限树形结构
  organizationPrivilege: {
    url: "/organization/",
    urlEnd: "/privilege/data",
    method: "post",
    lodingState: true
  },
  // 17.7.更新部门权限,职位权限
  organizationPrivilege2: {
    url: "/organization/update/",
    urlEnd: "/privilege",
    method: "post",
    lodingState: true
  },
  // 17.12.删除部门和人员
  organizationDelete: {
    url: "/organization/",
    urlEnd: "/delete",
    method: "post",
    lodingState: true
  },
  // 添加新职位
  organizationAdd: {
    url: "/organization/",
    urlEnd: "/add",
    method: "post",
    lodingState: true
  },
  organizationUpdate: {
    url: "/organization/update/",
    urlEnd: "void",
    method: "post",
    lodingState: true
  },
  // 14.11.项目添加单位角色
  addProjectCompanyRole: {
    url: "/projectUser/",
    urlEnd: "/addProjectCompanyRole",
    method: "post",
    lodingState: true
  },
  // 14.17.获取对应角色的公司人员信息
  selectCompanyAllByCompanyId: {
    url: "/projectUser/",
    urlEnd: "/selectCompanyAllByCompanyId",
    method: "post",
    lodingState: true
  },
  // 14.28.app端项目添加人员
  addUsersToProject: {
    url: "/projectUser/",
    urlEnd: "/addUsersToProject",
    method: "post",
    lodingState: true
  },
  // 14.23.查询部门下所有子部门
  selectProjectDepartment: {
    url: "/projectUser/",
    urlEnd: "/selectProjectDepartment",
    method: "post",
    lodingState: true
  },
  // 14.25.项目中调整部门/职位
  moveProjectJobs: {
    url: "/projectUser/",
    urlEnd: "/moveProjectJobs",
    method: "post",
    lodingState: true
  },
  // 14.24.调整职位初始化可选职位
  canReviseJobs: {
    url: "/projectUser/",
    urlEnd: "/canReviseJobs",
    method: "post",
    lodingState: true
  },
  // 14.4.查询上级职位权限
  selectParentProjectDepartmentPrivilege: {
    url: "/projectPrivilege/",
    urlEnd: "/selectParentProjectDepartmentPrivilege",
    method: "post",
    lodingState: true
  },
  // 14.6.修改部门/职位权限
  updatePrivilege: {
    url: "/projectPrivilege/",
    urlEnd: "/updatePrivilege",
    method: "post",
    lodingState: true
  },
  // 14.8.删除部门
  deleteProjectDepartmentByDepartmentId: {
    url: "/projectPrivilege/",
    urlEnd: "/deleteProjectDepartmentByDepartmentId",
    method: "post",
    lodingState: true
  },
  // 14.7.删除职位
  deleteProjectJobByJobId: {
    url: "/projectPrivilege/",
    urlEnd: "/deleteProjectJobByJobId",
    method: "post",
    lodingState: true
  },
  // 16.32.项目批量删除人员(web)
  deleteUserFormProjectWeb: {
    url: "/projectUser/",
    urlEnd: "/deleteUserFormProjectWeb",
    method: "post",
    lodingState: true
  },
  // 1.8.47.删除单位角色
  deleteCompanyRole: {
    url: "/project/",
    urlEnd: "/deleteCompanyRole",
    method: "post",
    lodingState: true
  },
  // 修改部门/职位名称
  updateDepartmentNameByJoBId: {
    url: "/projectPrivilege/",
    urlEnd: "/updateDepartmentNameByJoBId",
    method: "post",
    lodingState: true
  },
  // 14.3.添加子部门/职位
  addChildProjectDepartmentByProjectId: {
    url: "/projectPrivilege/",
    urlEnd: "/addChildProjectDepartmentByProjectId",
    method: "post",
    lodingState: true
  },
  // 项目添加角色单位模糊查询公司
  selectCompanyByCompanyName: {
    url: "/project/",
    urlEnd: "/selectCompanyByCompanyName",
    method: "post",
    lodingState: true
  },
  // 企业人员
  companyUsers: {
    url: "/organization/select/company/users",
    method: "post",
    lodingState: true
  },
  // 保证金申请退还消息提醒
  profileSendMsg: {
    url: "/deposit/list/own/profile/sendMsg",
    method: "post",
    lodingState: true
  },
  // 保证金同意退还后上传凭证
  uploadDepositPayCredentials: {
    url: "/deposit/uploadDepositPayCredentials/finance",
    method: "post",
    lodingState: true
  },
  // 20.1.6.保证金缴纳申请
  payInit: {
    url: "/deposit/pay/init",
    method: "post",
    lodingState: true
  },
  // 20.1.14.业务员查看保证金详情
  ownProfile: {
    url: "/deposit/list/own/profile",
    method: "post",
    lodingState: true
  },
  // 20.2.10.财务人员查看保证金详情
  financeProfile: {
    url: "/deposit/list/finance/profile",
    method: "post",
    lodingState: true
  },
  // 20.2.1.进行保证金审批
  depositReview: {
    url: "/deposit/review",
    method: "post",
    lodingState: true
  },
  // 12.35.审批撤销
  approveBackout: {
    url: "/approve/approveBackout",
    method: "post",
    lodingState: true
  },
  // 20.2.2.保证金线下操作后，上传回执单
  depositReceipt: {
    url: "/deposit/receipt",
    method: "post",
    lodingState: true
  },
  // 20.2.4.查询企业保证金费用清单项
  depositInventory: {
    url: "/deposit/inventory",
    method: "post",
    lodingState: true
  },
  // 20.1.9.保证金退还申请
  repayInit: {
    url: "/deposit/repay/init",
    method: "post",
    lodingState: true
  },
  // 20.1.11.保证金退还确认
  confirmation: {
    url: "/deposit/confirmation",
    method: "post",
    lodingState: true
  },
  // 20.1.1.保证金审批列表
  ownApprove: {
    url: "/deposit/list/own/approve",
    method: "post",
    lodingState: true
  },
  // 20.2.8.财务人员条件查询企业保证金列表
  finance2: {
    url: "/deposit/list/finance",
    method: "post",
    lodingState: true
  },
  // 20.2.9.财务人员查询需要自己审批的保证金列表
  financeHandle: {
    url: "/deposit/list/finance/handle",
    method: "post",
    lodingState: true
  },
  // 20.1.3.保证金审批模糊查询
  approveFuzzy: {
    url: "/deposit/list/own/approve/fuzzy",
    method: "post",
    lodingState: true
  },
  // 20.1.5.保证金查询
  depositQuery: {
    url: "/deposit/query",
    method: "post",
    lodingState: true
  },
  // 20.1.4.保证金额导出excel
  depositExcel: {
    url: "/deposit/excel",
    method: "post",
    lodingState: true
  },
  // 20.2.11.保证金资金统计信息
  statisticsFund: {
    url: "/deposit/statistics/fund",
    method: "post",
    lodingState: true
  },
  // 20.2.12.扣费项统计信息
  statisticsFundDeduct: {
    url: "/deposit/statistics/fund/deduct",
    method: "post",
    lodingState: true
  },
  // 20.2.7.删除企业保证金清单项
  inventoryDelete: {
    url: "/deposit/inventory/delete",
    method: "post",
    lodingState: true
  },
  // 20.2.5.增加保证金费用清单项
  inventorySave: {
    url: "/deposit/inventory/save",
    method: "post",
    lodingState: true
  },
  // 13.5.进行拨款
  operatePaymentByPaymentId: {
    url: "/company/operatePaymentByPaymentId",
    method: "post",
    lodingState: true
  },
  // 13.6.查看已拨款
  queryPaymentByPaymentId: {
    url: "/company/",
    urlEnd: "/queryPaymentByPaymentId",
    method: "post",
    lodingState: true
  },
  getProjectPaymentListWEB: {
    url: "/company/getProjectPaymentListWEB",
    method: "post",
    lodingState: true
  },
  // 13.1.查询拨款资料清单
  getPaymentInventoryByCompany: {
    url: "/company/getPaymentInventoryByCompany",
    method: "post",
    lodingState: true
  },
  uploadPaymentInventoryWEB: {
    url: "/company/uploadPaymentInventoryWEB",
    method: "post",
    lodingState: true
  },
  // 13.5.进行拨款
  operatePaymentByPaymentId: {
    url: "/company/operatePaymentByPaymentId",
    method: "post",
    lodingState: true
  },
  // 1.1.统计投资总金额
  totalFunds: {
    url: "/project/totalFunds",
    method: "post",
    lodingState: true
  },
  // 1.2.统计项目
  projectStat: {
    url: "/project/stat",
    method: "post",
    lodingState: true
  },
  statWeb: {
    url: "project/region/stat/web",
    method: "post",
    lodingState: true
  },
  systemMap: {
    url: "/system/map",
    method: "post",
    lodingState: true
  },
  // 18.2.3.查询有待盖章和已盖章的项目列表
  signProject: {
    url: "/enter/sign/project",
    method: "post",
    lodingState: true
  },
  // 企业管理
  taskListWeb: {
    url: "enter/sign/task/list/web",
    method: "post",
    lodingState: true
  },
  // 18.2.4.查询项目中待盖章或已盖章文件列表
  signFiles: {
    url: "/enter/sign/",
    urlEnd: "/files",
    method: "post",
    lodingState: true
  },
  // 18.2.9.发起签章
  signSeal: {
    url: "/enter/sign/seal",
    method: "post",
    lodingState: true
  },
  // 18.2.10.获取签章结果
  signResult: {
    url: "/enter/sign/result",
    method: "post",
    lodingState: true
  },
  // 18.2.2.查询用户开通企业签章状态
  signMsspId: {
    url: "/enter/sign/msspId",
    method: "post",
    lodingState: true
  },
  libraryWeb: {
    url: "enter/sign/library/web",
    method: "post",
    lodingState: true
  },
  // 2.1.15.修改企业证书详情
  updateCompanyCredential: {
    url: "/company/updateCompanyCredential",
    method: "post",
    lodingState: true
  },
  // 2.1.9.新增企业证书
  addCompanyCredential: {
    url: "/company/addCompanyCredential",
    method: "post",
    lodingState: true
  },
  // 26.1 进度展示（树形结构）
  getQuestTree: {
    url: "/projectQuest/",
    urlEnd: "/getQuestTree",
    method: "post",
    lodingState: true
  },
  //26.2 进度展示（条形结构）
  getQuestPmgressbar: {
    url: "/projectQuest/",
    urlEnd: "/getQuestPmgressbar",
    method: "post",
    lodingState: true
  },
  // 26.4 新建进度
  postAddMilestone: {
    url: "/projectQuest/",
    urlEnd: "/addMilestone",
    method: "post",
    lodingState: true
  },
  // 26.8 新建任务
  postCreateQuest: {
    url: "/projectQuest/",
    urlEnd: "/createQuest",
    method: "post",
    lodingState: true
  },
  // 查询进度列表
  searchMilestoneList: {
    url: "/projectQuest/",
    urlEnd: "/searchMilestoneList",
    method: "post",
    lodingState: true
  },
  // 上报进度
  addMilestone: {
    url: "/projectQuest/",
    urlEnd: "/addMilestone",
    method: "post",
    lodingState: true
  },
  // 26.9 删除任务
  deleteQuest: {
    url: "/projectQuest/",
    urlEnd: "/deleteQuest",
    method: "post",
    lodingState: true
  },
  // 26.5 修改进度
  updateQuest: {
    url: "/projectQuest/",
    urlEnd: "/updateQuest",
    method: "post",
    lodingState: true
  },
  // 26.12 任务导出
  excelExport: {
    url: "/projectQuest/",
    urlEnd: "/excelExport",
    method: "post",
    lodingState: true
  },
  // 26.11 模糊查询任务
  fuzzyQueryQuest: {
    url: "/projectQuest/",
    urlEnd: "/fuzzyQueryQuest",
    method: "post",
    lodingState: true
  },
  // 查询任务详情
  queryQuest: {
    url: "/projectQuest/",
    urlEnd: "/queryQuest",
    method: "post",
    lodingState: true
  },
  // 修改任务
  updateMilestone: {
    url: "/projectQuest/",
    urlEnd: "/updateMilestone",
    method: "post",
    lodingState: true
  },
  // 修改任务
  importPlanExcel: {
    url: "/projectQuest/",
    urlEnd: "/importPlanExcel",
    method: "post",
    lodingState: true
  },
  // 获取项目详情中的进度信息
  getProject: {
    url: "project/",
    urlEnd: "/getProject",
    method: "post",
    lodingState: true
  },
  // 项目进度管理
  selectProjectProgressList: {
    url: "/project/selectProjectProgressList",
    method: "post",
    lodingState: true
  },
  healthData: {
    url: "health/healthData",
    method: "post",
    lodingState: true
  },
  // 添加企业人员
  addUserToCompany: {
    url: "organization/addUserToCompany",
    method: "post",
    lodingState: true
  },
  // 获取部门
  departmentChoose: {
    url: "/organization/data/department/choose/",
    urlEnd: "void",
    method: "post",
    lodingState: true
  },
  // 通过手机号获取userName
  selectAllUsersByMobile: {
    url: "project/selectAllUsersByMobile",
    method: "post",
    lodingState: true
  },
  // 手机号获取userName
  getSummaryInformation: {
    url: "health/getSummaryInformation",
    method: "post",
    lodingState: true
  },
  // 文件附件检查
  checkFileType: {
    url: "project/file/checkFileType",
    method: "get",
    lodingState: true
  },
  // 获取附件信息
  getAttachment: {
    url: "project/file/getAttachment",
    method: "get",
    lodingState: true
  },

  // 资金拨付申请-明细
  fundingApplicationDetails: {
    url: "project/",
    urlEnd: "/projectFund/fundingApplicationDetails",
    method: "post",
    lodingState: true
  },
  // 资金拨付申请-人员
  fundingApplicationPerson: {
    url: "project/",
    urlEnd: "/projectFund/fundingApplicationPerson",
    method: "post",
    lodingState: true
  },
  // 资金拨付申请-人员明细查询
  PersonnelPaymentRecords: {
    url: "company/PersonnelPaymentRecords",
    method: "post",
    lodingState: true
  },
  // 工程款拨付
  projectPayment: {
    url: "company/projectPayment",
    method: "post",
    lodingState: true
  },
  // 工程款拨付-分类统计
  FundStatusStatisticsApp: {
    url: "company/FundStatusStatisticsApp",
    method: "post",
    lodingState: true
  },
  // 工程款拨付-分类统计-分类统计明细
  projectPaymentDetails: {
    url: "company/projectPaymentDetails",
    method: "post",
    lodingState: true
  },
  // 工程款拨付-分类统计-人员明细
  projectPaymentPersonnelDetails: {
    url: "/company/projectPaymentPersonnelDetails",
    method: "post",
    lodingState: true
  },
  // 获取公司下所有项目的资金审批统计（所有项目和单个项目共用）
  allOrOneProjectApproveCount: {
    url: "/approve/count/allOrOneProjectApproveCount",
    method: "get",
    lodingState: true
  },
  // 获取公司下所有项目的资金审批统计列表（所有项目）
  allProjectApproveCountList: {
    url: "/approve/count/allProjectApproveCountList",
    method: "get",
    lodingState: true
  },
  // 获取单个项目下资金申请明细
  projectApproveDetailsList: {
    url: "/approve/count/projectApproveDetailsList",
    method: "get",
    lodingState: true
  },
  // 获取单个项目下资金申请明细
  projectApproveUserList: {
    url: "/approve/count/projectApproveUserList",
    method: "get",
    lodingState: true
  },
  // 获取单个项目下资金申请明细（某个人的拨付列表记录）
  projectApproveOneUserList: {
    url: "/approve/count/projectApproveOneUserList",
    method: "get",
    lodingState: true
  },
  approveMoneyCount: {
    url: "/approve/count/approveMoneyCount",
    method: "get",
    lodingState: true
  },
  // 收藏项目
  myFavoriteItemsList: {
    url: "/projectSources/myFavoriteItemsList",
    method: "post",
    lodingState: true
  },
  // 新增我收藏的项目
  myFavoriteItemsAdd: {
    url: "/projectSources/myFavoriteItemsAdd",
    method: "post",
    lodingState: true
  },
  // 删除我收藏的项目
  myFavoriteItemsDelete: {
    url: "/projectSources/myFavoriteItemsDelete",
    method: "post",
    lodingState: true
  },
  // 获取登录人信息
  webJumpPage: {
    url: "/user/webJumpPage",
    method: "post",
    lodingState: true
  },
  // 资金拨付申请-人员明细查询
  fundingPersonDetails: {
    url: "/project/",
    urlEnd: "/projectFund/fundingPersonDetails",
    method: "post",
    lodingState: true
  },
  // 出差管理-审批列表
  getApprovesList: {
    url: "/businessTrip/getApprovesList",
    method: "post",
    lodingState: true
  },
  // 出差管理-个人出差记录详情
  getPersonalRecordDetails: {
    url: "/businessTrip/getPersonalRecordDetails",
    method: "post",
    lodingState: true
  },
  // 个人出差记录列表
  getPersonalBusinessTripRecord: {
    url: "/businessTrip/getPersonalBusinessTripRecord",
    method: "post",
    lodingState: true
  },
  // 获取出差地区
  getRegionsAndUsers: {
    url: "/businessTrip/getRegionsAndUsers",
    method: "post",
    lodingState: true
  },
  // 出差申请
  apply: {
    url: "/businessTrip/apply",
    method: "post",
    lodingState: true
  },
  // 再次发起出差申请
  updateApply: {
    url: "/businessTrip/update",
    method: "post",
    lodingState: true
  },
  // 出差管理-通过或者驳回审批
  approvedOrRejected: {
    url: "/businessTrip/approvedOrRejected",
    method: "post",
    lodingState: true
  },
  // 按照行政区划统计出差次数
  statisticsRegion: {
    url: "/businessTrip/statistics/region",
    method: "post",
    lodingState: true
  },
  // 按照企业部门统计出差次数
  companyDepartment: {
    url: "/businessTrip/statistics/companyDepartment",
    method: "post",
    lodingState: true
  },
  // 按照月份统计出差数据
  statisticsMonth: {
    url: "/businessTrip/statistics/month",
    method: "post",
    lodingState: true
  },
  searchAndStatistics: {
    url: "/businessTrip/searchAndStatistics",
    method: "post",
    lodingState: true
  },
  //创建或修改仓库详情数据
  createOrUpdateWarehouseData: {
    url: "/warehouse/",
    urlEnd: "/createOrUpdateWarehouseData",
    method: "post",
    lodingState: true,
    doadmin: "materials"
  },
  //删除仓库信息
  deleteWarehouseList: {
    url: "/warehouse/",
    urlEnd: "/deleteWarehouseList",
    method: "post",
    lodingState: true,
    doadmin: "materials"
  },
  // 查询仓库信息列表
  selectWarehouseList: {
    url: "/warehouse/",
    urlEnd: "/selectWarehouseList",
    method: "post",
    lodingState: true,
    doadmin: "materials"
  },
  // 验收列表
  getAcceptanceBatchRecord: {
    url: "/material/",
    urlEnd: "/getAcceptanceBatchRecord",
    method: "post",
    lodingState: true,
    doadmin: "materials"
  },

  // 查询某一批次详情验收记录
  getAcceptanceRecord: {
    url: "/material/",
    urlEnd: "/getAcceptanceRecord",
    method: "post",
    lodingState: true,
    doadmin: "materials"
  },
  // 查询某一批次详情验收记录附件
  getAcceptanceRecordAnnex: {
    url: "/material/",
    urlEnd: "/getAcceptanceRecordAnnex",
    method: "post",
    lodingState: true,
    doadmin: "materials"
  },
  // 查询已添加验收材料
  getAcceptance: {
    url: "/material/",
    urlEnd: "/getAcceptanceMaterial",
    method: "post",
    lodingState: true,
    doadmin: "materials"
  },
  // 查询已添加验收材料
  getAddedMaterial: {
    url: "/material/getAddedMaterial",
    method: "post",
    lodingState: true,
    doadmin: "materials"
  },

  // 新增或编辑材料
  createOrUpdateMaterial: {
    url: "/material/",
    urlEnd: "/createOrUpdateMaterial",
    method: "post",
    lodingState: true,
    doadmin: "materials"
  },
  //查询所有材料单位列表
  selectAllUnit: {
    url: "/unit/",
    urlEnd: "/selectAllUnit",
    method: "post",
    lodingState: true,
    doadmin: "materials"
  },
  //仓库树形结构
  getMaterialTypeTree: {
    url: "/material/",
    urlEnd: "/getMaterialTypeTree",
    method: "post",
    lodingState: true,
    doadmin: "materials"
  },
  //查询仓库各种材料的库存
  getMaterialWarehouseInventory: {
    url: "/warehouse/",
    urlEnd: "/getMaterialWarehouseInventory",
    method: "post",
    lodingState: true,
    doadmin: "materials"
  },
  //材料分类-重命名
  updateMaterialType: {
    url: "/material/",
    urlEnd: "/updateMaterialType",
    method: "post",
    lodingState: true,
    doadmin: "materials"
  },
  //新建材料分类
  createMaterialType: {
    url: "/material/",
    urlEnd: "/createMaterialType",
    method: "post",
    lodingState: true,
    doadmin: "materials"
  },
  //删除材料分类
  deleteMaterialType: {
    url: "/material/",
    urlEnd: "/deleteMaterialType",
    method: "post",
    lodingState: true,
    doadmin: "materials"
  },
  //添加验收记录
  addAcceptanceRecord: {
    url: "/material/",
    urlEnd: "/addAcceptanceRecord",
    method: "post",
    lodingState: true,
    doadmin: "materials"
  },
  //获取已入库列表
  getTheListOfWarehouses: {
    url: "/warehouse/",
    urlEnd: "/getTheListOfWarehouses",
    method: "post",
    lodingState: true,
    doadmin: "materials"
  },
  //查询待入库或者待签字
  queryWaitingEnterWarehouse: {
    url: "/warehouse/",
    urlEnd: "/queryWaitingEnterWarehouse",
    method: "post",
    lodingState: true,
    doadmin: "materials"
  },
  //删除材料分类
  getMaterialWarehouseInventoryDetails: {
    url: "/warehouse/",
    urlEnd: "/getMaterialWarehouseInventoryDetails",
    method: "post",
    lodingState: true,
    doadmin: "materials"
  },
  //删除材料
  deleteMaterial: {
    url: "/material/",
    urlEnd: "/deleteMaterial",
    method: "post",
    lodingState: true,
    doadmin: "materials"
  },
  //批量新增或者修改材料单位
  addBatchMaterialUnit: {
    url: "/unit/",
    urlEnd: "/addBatchMaterialUnit",
    method: "post",
    lodingState: true,
    doadmin: "materials"
  },
  //删除材料单位
  deleteMaterialUnit: {
    url: "/unit/",
    urlEnd: "/deleteMaterialUnit",
    method: "post",
    lodingState: true,
    doadmin: "materials"
  },
  //获取盘点信息详情
  queryWarehouseInventoryDetail: {
    url: "/warehouse/inventory/",
    urlEnd: "/queryWarehouseInventoryDetail",
    method: "post",
    lodingState: true,
    doadmin: "materials"
  },
  //添加盘点类型详情
  addAcceptanceMaterial: {
    url: "/warehouse/inventory/",
    urlEnd: "/addAcceptanceMaterial",
    method: "post",
    lodingState: true,
    doadmin: "materials"
  },
  //查询盘点类型详情
  getAcceptanceMaterial: {
    url: "/warehouse/inventory/",
    urlEnd: "/getAcceptanceMaterial",
    method: "post",
    lodingState: true,
    doadmin: "materials"
  },
  //获取盘点信息
  queryWarehouseInventory: {
    url: "/warehouse/inventory/",
    urlEnd: "/queryWarehouseInventory",
    method: "post",
    lodingState: true,
    doadmin: "materials"
  },
  //获取盘点信息详情附件
  queryWarehouseInventoryAtt: {
    url: "/warehouse/inventory/",
    urlEnd: "/queryWarehouseInventoryAtt",
    method: "post",
    lodingState: true,
    doadmin: "materials"
  },
  //用户签字
  userSign: {
    url: "/warehouse/inventory/",
    urlEnd: "/userSign",
    method: "post",
    lodingState: true,
    doadmin: "materials"
  },
  // 查询保证金账户信息
  queryBankAccount: {
    url: "deposit/queryBankAccount",
    method: "post",
    lodingState: true
  },
  // 添加或者修改保证金账号信息
  addOrUpdateBankAccount: {
    url: "deposit/addOrUpdateBankAccount",
    method: "post",
    lodingState: true
  },
  // 删除保证金账号信息
  deleteBankAccount: {
    url: "deposit/deleteBankAccount",
    method: "post",
    lodingState: true
  },
  // 施工日志收藏列表接口
  constructionLogFavoritesList: {
    url: "constructionLog/ConstructionLogFavoritesList",
    method: "post",
    lodingState: true
  },
  // 监理日志收藏列表接口
  getSupervisionLogFavorites: {
    url: "supervision/getSupervisionLogFavorites",
    method: "post",
    lodingState: true
  },
  //
  getSupervisionLogFavorites: {
    url: "supervision/getSupervisionLogFavorites",
    method: "post",
    lodingState: true
  },
  //添加入库
  addEnterWarehouse: {
    url: "/warehouse/",
    urlEnd: "/addEnterWarehouse",
    method: "post",
    lodingState: true,
    doadmin: "materials"
  },
  //获取待签字批次或已入库详情
  getDetailsOfTheBatchToBeSigned: {
    url: "/warehouse/",
    urlEnd: "/getDetailsOfTheBatchToBeSigned",
    method: "post",
    lodingState: true,
    doadmin: "materials"
  },
  //待入库签字确认
  signToConfirm: {
    url: "/warehouse/signToConfirm",
    urlEnd: "/signToConfirm",
    method: "post",
    lodingState: true,
    doadmin: "materials"
  },
  //获取入库批次详情
  getStorageDetails: {
    url: "/warehouse/",
    urlEnd: "/getStorageDetails",
    method: "post",
    lodingState: true,
    doadmin: "materials"
  },
  //确认验收入库
  acceptanceEnterWarehouse: {
    url: "/warehouse/",
    urlEnd: "/acceptanceEnterWarehouse",
    method: "post",
    lodingState: true,
    doadmin: "materials"
  },
  //获取发料列表
  getTheIssueList: {
    url: "/warehouse/",
    urlEnd: "/getTheIssueList",
    method: "post",
    lodingState: true,
    doadmin: "materials"
  },
  //获取发料材料列表
  getAListOfMaterialsExitStorage: {
    url: "/warehouse/",
    urlEnd: "/getAListOfMaterialsExitStorage",
    method: "post",
    lodingState: true,
    doadmin: "materials"
  },
  //添加发料申请或重新发起发料申请
  addIssueRequest: {
    url: "/warehouse/",
    urlEnd: "/addIssueRequest",
    method: "post",
    lodingState: true,
    doadmin: "materials"
  },

  //获取发料批次详情
  getDetailsOfExitBatch: {
    url: "/warehouse/",
    urlEnd: "/getDetailsOfExitBatch",
    method: "post",
    lodingState: true,
    doadmin: "materials"
  },
  //处理待审批发料
  processingApproveExitBatch: {
    url: "/warehouse/",
    urlEnd: "/processingApproveExitBatch",
    method: "post",
    lodingState: true,
    doadmin: "materials"
  },
  //确认发料
  confirmIssue: {
    url: "/warehouse/",
    urlEnd: "/confirmIssue",
    method: "post",
    lodingState: true,
    doadmin: "materials"
  },
  //发料签字确认
  signToConfirmExitBatch: {
    url: "/warehouse/signToConfirmExitBatch",
    urlEnd: "/signToConfirmExitBatch",
    method: "post",
    lodingState: true,
    doadmin: "materials"
  },
  //盘点后的树形结构
  getMaterialTree: {
    url: "/warehouse/inventory/",
    urlEnd: "/getMaterialTree",
    method: "post",
    lodingState: true,
    doadmin: "materials"
  },
  //获取项目下生厂商列表
  getSupplierName: {
    url: "/material/",
    urlEnd: "/getSupplierName",
    method: "post",
    lodingState: true,
    doadmin: "materials"
  },
  //获取盘点前的树形结构
  getWarehouseMaterialTree: {
    url: "/warehouse/inventory/",
    urlEnd: "/getWarehouseMaterialTree",
    method: "post",
    lodingState: true,
    doadmin: "materials"
  },
  //获取施工部位
  queryConstructionSite: {
    url: "/warehouse/",
    urlEnd: "/queryConstructionSite",
    method: "post",
    lodingState: true,
    doadmin: "materials"
  },
  //获取保证金新增时的默认账户
  depositQueryBankInformation: {
    url: "/deposit/queryBankInformation",
    method: "post",
    lodingState: true
  },
  //获取最大批次
  maxApply: {
    url: "/project/",
    urlEnd: "/projectFund/maxApply",
    method: "post",
    lodingState: true
  },
  //保证金审批导出Excel
  exportUserMarginApproveList: {
    url: "/deposit/excel/exportUserMarginApproveList",
    method: "post",
    lodingState: true
  },
  // 物资审批列表接口
  getMaterialApproval: {
    url: "/approve/getMaterialApproval",
    method: "post",
    lodingState: true
  },
  //常用联系人 企业
  companyFrequentlyApproveUser: {
    url: "/approve/companyFrequentlyApproveUser",
    method: "post",
    lodingState: true
  },
  //常用联系人 项目
  projectFrequentlyApproveUser: {
    url: "/approve/",
    urlEnd: "/projectFrequentlyApproveUser",
    method: "post",
    lodingState: true
  },
  //常用联系人 企项
  queryCompanyProjectApprover: {
    url: "/roster/",
    urlEnd: "/queryCompanyProjectApprover",
    method: "post",
    lodingState: true
  },
  //获取二维码
  qrCode: {
    url: "/user/qrCode",
    method: "post",
    lodingState: false
  },
  //获取二维码uuid
  randkey: {
    url: "/user/randkey",
    method: "post",
    lodingState: false
  },
  //web端扫码检查
  scan: {
    url: "/user/scan",
    method: "post",
    lodingState: false
  },
  //web端扫码登录检查
  scanLogin: {
    url: "/user/scanLogin",
    method: "post"
  },
  //企业-项目阶段  查询所有的大节点及对应子节点
  queryAllLargeNodesAndSmallNodes: {
    url: "/projectStage/projectStageTemplate",
    method: "post",
    lodingState: true
  },
  //企业-项目阶段  切换大节点或小节点条件查询
  changeNodesforList: {
    url: "/projectStage/projectStageList",
    method: "post",
    lodingState: true
  },
  //企业公告列表
  noticeList: {
    url: "/notice/list",
    method: "post",
    lodingState: true
  },
  //删除企业公告
  delNotice: {
    url: "/notice/",
    urlEnd: "/delNotice",
    method: "post",
    lodingState: true
  },
  //企业公告详情
  noticeDetail: {
    url: "/notice/",
    urlEnd: "/noticeDetail",
    method: "post",
    lodingState: true
  },
  //新增企业公告
  noticeInsertOrUpdate: {
    url: "/notice/insertOrUpdate",
    method: "post",
    lodingState: true
  },
  //企业公告
  animationEnterprise: {
    url: "notice/pushNotice",
    method: "post",
    lodingState: false
  },
  //企业-项目阶段  节点添加
  addReportInformation: {
    url: "/projectStage/",
    urlEnd: "/addReportInformation",
    method: "post",
    lodingState: true
  },
  //企业-项目阶段  列表查询
  queryStage: {
    url: "/projectStage/",
    urlEnd: "/queryStage",
    method: "post",
    lodingState: true
  },
  // 获取前期立项列表
  earlyStageProjectList: {
    url: "/projectSources/queryProject/EarlyStageProject",
    method: "post",
    lodingState: true
  },
  // 节点详情查询
  queryStageDetails: {
    url: "/projectStage/",
    urlEnd: "/queryStageDetails",
    method: "post",
    lodingState: true
  },
  //项目公告列表
  projectNoticeList: {
    url: "/project/notice/list",
    method: "post",
    lodingState: true
  },
  //删除项目公告
  projectDelNotice: {
    url: "/project/notice/",
    urlEnd: "/delNotice",
    method: "post",
    lodingState: true
  },
  //项目公告详情
  projectNoticeDetail: {
    url: "/project/notice/",
    urlEnd: "/noticeDetail",
    method: "post",
    lodingState: true
  },
  //新增项目公告
  projectNoticeInsertOrUpdate: {
    url: "/project/notice/",
    urlEnd: "/insertOrUpdate",
    method: "post",
    lodingState: true
  },
  //项目公告
  projectAnimationEnterprise: {
    url: "/project/notice/pushNotice",
    method: "post",
    lodingState: false
  },
  // 对项目添加劳务单位
  projectAddProjectCompanyRole: {
    url: "/project/",
    urlEnd: "/addProjectCompanyRole",
    method: "post",
    lodingState: false
  },
  //     合同档案列表
  contractFileList: {
    url: "/company/contract/contractFileList",
    method: "post",
    lodingState: true
  },

  //查询项目合同分类
  queryContractClassification: {
    url: "/project/contractClassification",
    method: "post",
    lodingState: true
  },
  //新增,编辑项目合同分类
  newAddContractClassification: {
    url: "/project/editContractClassification",
    method: "post",
    lodingState: true
  },
  //删除项目合同分类
  deleteContractClassification: {
    url: "/project/deleteContractClassification",
    method: "post",
    lodingState: true
  },
  //查询企业合同分类
  queryEnterPriseClassification: {
    url: "/company/contract/queryCompanyContractClassify",
    method: "post",
    lodingState: true
  },
  //企业合同分类新增或者编辑
  newAddEnterPriseClassification: {
    url: "/company/contract/editCompanyContractClassify",
    method: "post",
    lodingState: true
  },

  //企业合同分类新增或者编辑
  deleteEnterPriseClassification: {
    url: "/company/contract/deleteContractClassification",
    method: "post",
    lodingState: true
  },
  //查询合同交底信息(单查合同交底信息，不包含合同信息)
  contractPresentation: {
    url: "/project/",
    urlEnd: "/contractPresentation",
    method: "post",
    lodingState: true
  },
  // 获取合同档案详情(基本信息 + 交底记录 + 变更记录 + 索赔记录 + 计算记录)
  contractDetails: {
    url: "/project/",
    urlEnd: "/contractDetails",
    method: "post",
    lodingState: true
  },
  //通过合同id获取到项目合同的基本信息(合同信息 + 附件信息 + 预警信息)
  contract: {
    url: "/project/",
    urlEnd: "/contract",
    method: "post",
    lodingState: true
  },
  //获取合同索赔信息（不包含合同信息）
  contractClaim: {
    url: "/project/",
    urlEnd: "/contractClaim",
    method: "post",
    lodingState: true
  },
  // 获取合同变更基本详情（不包含合同基本信息）
  contractChange: {
    url: "/project/",
    urlEnd: "/contractChange",
    method: "post",
    lodingState: true
  },
  //查询企业下所有项目合同档案详情
  allProjectContractDetails: {
    url: "/project/",
    urlEnd: "/contractDetail",
    method: "post",
    lodingState: true
  },
  //查询企业合同档案详情
  queryCompanyContractChange: {
    url: "/company/contract/queryCompanyContractChange",
    method: "post",
    lodingState: true
  },
  //获取合同新增合同窗口的预警提醒信息
  contractWarningTypeList: {
    url: "/project/contractWarningTypeList",
    method: "post",
    lodingState: true
  },
  //处理方式
  processingStatus: {
    url: "/project/processingStatus",
    method: "post",
    lodingState: true
  },
  //合同类型
  contractClassification: {
    url: "/project/contractClassification",
    method: "post",
    lodingState: true
  },
  //合同状态
  contractStatus: {
    url: "/project/contractStatus",
    method: "post",
    lodingState: true
  },
  //变更类型
  changeType: {
    url: "/project/changeType",
    method: "post",
    lodingState: true
  },
  //合同索赔
  getContractClaimList: {
    url: "/company/contract/getContractClaimList",
    method: "post",
    lodingState: true
  },
  //合同 结算
  queryContractSettlement: {
    url: "/company/contract/queryContractSettlement",
    method: "post",
    lodingState: true
  },

  // 新增合同档案
  getProjectAddContract: {
    url: "/project/",
    urlEnd: "/addContract",
    method: "post",
    lodingState: true
  },
  // 项目合同档案
  contractFileListPro: {
    url: "/project/",
    urlEnd: "/contractFileList",
    method: "post",
    lodingState: true
  },
  // 项目合同交底
  contractPresentationList: {
    url: "/project/",
    urlEnd: "/contractPresentationList",
    method: "post",
    lodingState: true
  },
  // 项目合同索赔
  contractClaimList: {
    url: "/project/",
    urlEnd: "/contractClaimList",
    method: "post",
    lodingState: true
  },
  // 项目合同变更
  contractChangeList: {
    url: "/project/",
    urlEnd: "/contractChangeList",
    method: "post",
    lodingState: true
  },
  // 项目合同结算
  contractSettlementList: {
    url: "/project/",
    urlEnd: "/contractSettlementList",
    method: "post",
    lodingState: true
  },
  // 添加合同基本信息
  createCompanyContract: {
    url: "/company/contract/createCompanyContract",
    method: "post",
    lodingState: true
  },
  // 添加企业合同变更
  addCompanyContractChange: {
    url: "/company/contract/addCompanyContractChange",
    method: "post",
    lodingState: true
  },
  // 查询企业下所有合同列表
  queryCompanyContractList: {
    url: "/company/contract/queryCompanyContractList",
    method: "post",
    lodingState: true
  },

  // 所有项目合同
  // 项目合同档案
  getProjectContractList: {
    url: "/company/contract/getProjectContractList",
    method: "post",
    lodingState: true
  },
  //合同 交底
  getContractPreList: {
    url: "/company/contract/getContractPreList",
    method: "post",
    lodingState: true
  },
  // 项目合同索赔
  projectContractClaimList: {
    url: "/company/contract/projectContractClaimList",
    method: "post",
    lodingState: true
  },
  // 项目合同变更
  allContractChangeList: {
    url: "/company/contract/contractChangeList",
    method: "post",
    lodingState: true
  },
  // 项目合同结算
  projectContractSettlementList: {
    url: "/company/contract/projectContractSettlementList",
    method: "post",
    lodingState: true
  },
  // 企业合同索赔新增
  addContractClaim: {
    url: "/company/contract/addContractClaim",
    method: "post",
    lodingState: true
  },
  // 查询选择项目下的合同
  getContractListByProjectId: {
    url: "/company/contract/",
    urlEnd: "/getContractListByProjectId",
    method: "post",
    lodingState: true
  },
  //
  projectContract: {
    url: "/project/",
    urlEnd: "/contract",
    method: "post",
    lodingState: true
  },
  //
  addContractPresentation: {
    url: "/project/",
    urlEnd: "/addContractPresentation",
    method: "post",
    lodingState: true
  },
  // 项目合同变更
  addContractChange: {
    url: "/project/",
    urlEnd: "/addContractChange",
    method: "post",
    lodingState: true
  },
  // 企业下企业合同详情共用table
  queryCompanyContract: {
    url: "company/contract/queryCompanyContract",
    method: "post",
    lodingState: true
  },
  // 企业下企业合同变更详情
  queryContractChange: {
    url: "/company/contract/queryContractChange",
    method: "post",
    lodingState: true
  },
  // 企业下企业合同索赔详情
  queryContractClaimDetail: {
    url: "/company/contract/queryContractClaimDetail",
    method: "post",
    lodingState: true
  },
  // 企业下企业合同结算详情
  queryContractSettlementDetail: {
    url: "/company/contract/queryContractSettlementDetail",
    method: "post",
    lodingState: true
  },
  // 企业下企业合同结算详情
  queryContract: {
    url: "/company/contract/queryContract",
    method: "post",
    lodingState: true
  },
  // 企业合同档案编口
  updateCompanyContract: {
    url: "/company/contract/updateCompanyContract",
    method: "post",
    lodingState: true
  },
  // 企业合同档案编口
  updateCompanyContractChange: {
    url: "/company/contract/updateCompanyContractChange",
    method: "post",
    lodingState: true
  },

  getUserCertificationStatus: {
    url: "/company/getUserCertificationStatus",
    method: "post",
    lodingState: true
  },
  // 企业合同档案编口
  updateContractClaim: {
    url: "/company/contract/updateContractClaim",
    method: "post",
    lodingState: true
  },
  // 修改项目合同信息
  updateContract: {
    url: "/project/",
    urlEnd: "/updateContract",
    method: "post",
    lodingState: true
  },
  // 变更项目合同交底信息
  updateContractPresentation: {
    url: "/project/",
    urlEnd: "/updateContractPresentation",
    method: "post",
    lodingState: true
  },
  // 变更项目合同交底信息
  updateContractChange: {
    url: "/project/",
    urlEnd: "/updateContractChange",
    method: "post",
    lodingState: true
  },
  // 变更项目合同交底信息
  projectAddContractClaim: {
    url: "/project/",
    urlEnd: "/addContractClaim",
    method: "post",
    lodingState: true
  },
  // 变更项目合同交底信息
  projectUpdateContractClaim: {
    url: "/project/",
    urlEnd: "/updateContractClaim",
    method: "post",
    lodingState: true
  },
  // 变更项目合同交底信息
  contractSettlementStr: {
    url: "/project/",
    urlEnd: "/contractSettlementStr",
    method: "post",
    lodingState: true
  },

  // 合同删除接口
  // 删除档案
  deleteContract: {
    url: "/project/",
    urlEnd: "/deleteContract",
    method: "post",
    lodingState: true
  },
  // 删除合同交底信息（物理删除）
  deleteContractPresentation: {
    url: "/project/",
    urlEnd: "/deleteContractPresentation",
    method: "post",
    lodingState: true
  },
  // 删除合同索赔信息
  deleteContractClaim: {
    url: "/project/",
    urlEnd: "/deleteContractClaim",
    method: "post",
    lodingState: true
  },
  // 删除合同变更信息(物理删除)
  deleteContractChange: {
    url: "/project/",
    urlEnd: "/deleteContractChange",
    method: "post",
    lodingState: true
  },

  // 企业合同删除接口
  // 删除档案
  comDeleteContract: {
    url: "/company/contract/deleteContract",
    method: "post",
    lodingState: true
  },
  // 删除合同变更信息(物理删除)
  deleteCompanyContractChange: {
    url: "/company/contract/deleteCompanyContractChange",
    method: "post",
    lodingState: true
  },

  // 删除合同索赔信息
  comDeleteContractClaim: {
    url: "/company/contract/deleteContractClaim",
    method: "post",
    lodingState: true
  },
  // 添加项目合同结算信息
  addContractSettlement: {
    url: "/project/",
    urlEnd: "/addContractSettlement",
    method: "post",
    lodingState: true
  },
  //  结算信息
  companyAddContractSettlement: {
    url: "/company/contract/addContractSettlement",
    method: "post",
    lodingState: true
  },
  //  商务报价详情
  queryBusinessOffer: {
    url: "/businessOffer/queryBusinessOffer",
    method: "post",
    lodingState: true
  },
  //  获取所有可用系统报价清单配置（添加报价前）
  systemConfiguration: {
    url: "/businessOffer/systemConfiguration",
    method: "post",
    lodingState: true
  },
  //   商务列表
  getBusinessOfferList: {
    url: "/businessOffer/getBusinessOfferList",
    method: "post",
    lodingState: true
  },
  //   商务列表  删除
  deleteBusinessOffer: {
    url: "/businessOffer/deleteBusinessOffer",
    method: "post",
    lodingState: true
  },
  //   商务列表    提交采购
  addPurchaseOrder: {
    url: "/businessOffer/addPurchaseOrder",
    method: "post",
    lodingState: true
  },
  // 新增商务报价
  addBusinessOffer: {
    url: "/businessOffer/addBusinessOffer",
    method: "post",
    lodingState: true
  },
  // 修改商务报价
  editBusinessOffer: {
    url: "/businessOffer/editBusinessOffer",
    method: "post",
    lodingState: true
  },
  // 获取出差审批数量
  getApprovesTotal: {
    url: "/businessTrip/getApprovesTotal",
    method: "post",
    lodingState: true
  },
  // 获取合同的开始和结束时间
  getContractDate: {
    url: "/supervision/getContractDate",
    method: "post",
    lodingState: true
  },
  // 更新合同的开始和结束时间
  updateContractDate: {
    url: "/supervision/updateContractDate",
    method: "post",
    lodingState: true
  },
  getCityList: {
    url: "/version/region/download",
    method: "post",
    lodingState: true
  },
  comPanyeRegister: {
    url: "/company/companyRegister",
    method: "post",
    lodingState: true
  },
  getCompanyType: {
    url: "/company/getCompanyTypeDir",
    method: "post",
    lodingState: true
  },
  // 项目快速初始化-excel导入项目初始化
  importExcel: {
    url: "/project/importExcel",
    method: "post",
    lodingState: true
  },
  // 项目快速初始化-导入excel解析结果列表
  getCacheList: {
    url: "/project/getCacheList",
    method: "get",
    lodingState: true
  },
  // 项目快速初始化-预览导入模板信息
  getInitCacheInfo: {
    url: "/project/getInitCacheInfo",
    method: "get",
    lodingState: true
  },
  // 项目快速初始化-持久化导入信息
  saveImportInfo: {
    url: "/project/saveImportInfo",
    method: "post",
    lodingState: true
  },
  // 项目快速初始化-编辑导入模板信息
  changeCache: {
    url: "/project/",
    urlEnd: "/changeCache",
    method: "post",
    lodingState: true
  },
  verifyCompany: {
    url: "/company/verifyCompany",
    method: "post",
    lodingState: true
  },
  // 安全质量检查-考核评比统计
  assessmentEvaluation: {
    url: "/securityCheck/",
    urlEnd: "/assessmentEvaluation",
    method: "post",
    lodingState: true
  },
  /*
 安全质量检查-检查记录列表或者整改记录列表
*/
  projectSecurityCheckList: {
    url: "/securityCheck/",
    urlEnd: "/projectSecurityCheckList",
    method: "post",
    lodingState: true
  },

  /*
  获取整改详情，表格点击过来
  */
  getRecordDetail: {
    url: "/securityCheck/getRecordDetail",
    method: "post",
    lodingState: true
  },

  /*
  提交复查审核， 复查不通过, 和复查通过
  */
  submitReview: {
    url: "/securityCheck/submitReview",
    method: "post",
    lodingState: true
  },

  /*
  提交整改
  */
  submitRectify: {
    url: "/securityCheck/submitRectify",
    method: "post",
    lodingState: true
  },

  // 获取检查内容的所有值,查询，7日新增， 第二个V2接口
  checkContentData: {
    url: "/securityCheck/checkContentData",
    method: "post",
    lodingState: true
  },

  // 删除检查内容，并返回所有值，7日新增， 第二个V2接口
  deleteCheckContent: {
    url: "/securityCheck/deleteCheckContent",
    method: "post",
    lodingState: true
  },

  // 添加检查内容，并返回所有值,  第二个V2接口
  addCheckContent: {
    url: "/securityCheck/addCheckContent",
    method: "post",
    lodingState: true
  },

  /*
  添加安全检查内容（web端批量添加）
  */
  addProjectSecurityCheck: {
    url: "/securityCheck/",
    urlEnd: "/addProjectSecurityCheck",
    method: "post",
    lodingState: true
  },

  /*
 安全质量检查-检查记录列表或者整改记录列表
*/
  saveProjectSecurityCheckFiles: {
    url: "/securityCheck/",
    urlEnd: "/saveProjectSecurityCheckFiles",
    method: "post",
    lodingState: true
  },

  /*
   获取整改情况
   */
  getRectifySituation: {
    url: "/securityCheck/getRectifySituation",
    method: "post",
    lodingState: true
  },
  //获取我的待办(整改列表)
  getMyRectify: {
    url: "/securityCheck/getMyRectify",
    method: 'post',
    lodingState: true

  },
  //流程提示信息查询列表
  getApproveTipsList: {
    url: "/companyAttendance/approveTips/list",
    method: 'post',
    lodingState: true
  },
  //获取请假类型
  getAttendanceType: {
    url: "/companyAttendance/attendanceType/list",
    method: 'post',
    lodingState: true
  },
  //流程提示信息新增
  approveTipsAdd: {
    url: "/companyAttendance/approveTips/add",
    method: 'post',
    lodingState: true
  },
  //流程提示信息新增
  approveTipsUpdate: {
    url: "/companyAttendance/approveTips/update",
    method: 'post',
    lodingState: true
  },
  //流程提示信息新增
  approveTipsDelete: {
    url: "/companyAttendance/approveTips/delete",
    method: 'post',
    lodingState: true
  },
  //智慧工地示例
  towerCraneMonitoringDataList: {
    url: "/towerCrane/towerCraneMonitoringDataList",
    method: 'post',
    lodingState: true,
    doadmin: "zhgdApi"
  },
  //发起审批
  getCompanyAttendanceApproveList: {
    url: "/companyAttendance/approve/list",
    method: 'post',
    lodingState: true
  },
  //抄送给我
  getApproveCopyList: {
    url: "/companyAttendance/approve/copyList",
    method: 'post',
    lodingState: true
  },
  //发起审批
  getUserInfo: {
    url: "/company/getUserInfo",
    method: 'post',
    lodingState: false
  },
  //个人档案编辑
  eidtPersonalInforMation: {
    url: "/emp/personFileEdit",
    method: 'post',
    lodingState: true
  },
  //入职申请  /company/entryJobApply
  getEntryJobApply: {
    url: "/company/entryJobApply",
    method: 'post',
    lodingState: true
  },
  //获取用户基本信息
  getuserInforOfApplye: {
    url: "/company/getUserInfo",
    method: 'post',
    lodingState: true
  },
  //获取说有的部门
  getDepartmentList: {
    url: "/company/getJobList",
    method: 'post',
    lodingState: true
  },
  //个人档案-详情入职详情
  getEntryJobDetails: {
    url: "/company/entryJobDetails",
    method: 'post',
    lodingState: true
  },
  //提交转正申请
  submitOfficialApply: {
    url: "/company/userOfficial",
    method: 'post',
    lodingState: true
  },

  //个人档案-申请离职申请
  submitDimissionApply: {
    url: "/company/userDimission",
    method: 'post',
    lodingState: true
  },
  //个人档案-离职详情
  getDimissionDetails: {
    url: "/company/dimissionDetails",
    method: 'post',
    lodingState: true
  },
  //人事审批-列表
  getEntryRecordLists: {
    url: "/emp/personnelFileApprovalList",
    method: 'post',
    lodingState: true
  },
  //人事审批-入职审批
  approvePersonalRecords: {
    url: "/company/approvePersonalRecords",
    method: 'post',
    lodingState: true
  },
  //个人档案-上传
  educationFileUpload: {
    url: "/emp/educationFileUpload",
    method: 'post',
    lodingState: true
  },
  //个人档案详情
  getEmpPersonalArchives: {
    url: "emp/empPersonalArchives",
    method: 'post',
    lodingState: true
  },
  //企业档案详情
  getEmpCompanyArchivesDetail: {
    url: "/emp/empCompanyArchivesDetail",
    method: 'post',
    lodingState: true
  },

  companyFileEdit: {
    url: "/emp/companyFileEdit",
    method: 'post',
    lodingState: true
  },
  //个人档案-转正详情
  getOfficialDetails: {
    url: "/company/officialDetails",
    method: 'post',
    lodingState: true
  },
  //提离职正申请
  submitDimissionApply: {
    url: "/company/userDimission",
    method: 'post',
    lodingState: true
  },
  //个人档案-转正详情
  getDimissionDetails: {
    url: "/company/dimissionDetails",
    method: 'post',
    lodingState: true
  },

  //获取员工档案列表
  getEmpArchivesList: {
    url: "/emp/empArchivesList",
    method: 'post',
    lodingState: true
  },
  //无权限 - 查询审批人
  getAllCompanyUser: {
    url: "/company/getAllCompanyUser",
    method: 'post',
    lodingState: true
  },
  //获取员工入职管理列表
  getEntryRecord: {
    url: "/emp/entryRecord",
    method: 'post',
    lodingState: true
  },

  //获取员工转正列表
  getConvertedRecord: {
    url: "/emp/convertedRecord",
    method: 'post',
    lodingState: true
  },

  //获取员工离职列表
  getResignRecord: {
    url: "/emp/resignRecord",
    method: 'post',
    lodingState: true
  },

  //获取假勤类型
  getLeaveTypeList: {
    url: "/companyAttendance/leaveType/list",
    method: 'post',
    lodingState: false
  },
  //计算审批的时长
  getCalculateDuration: {
    url: "/companyAttendance/calculateDuration",
    method: 'post',
    lodingState: false
  },
  //计算审批的时长
  attendanceApproval: {
    url: "/companyAttendance/approval",
    method: 'post',
    lodingState: true
  },
  //流程提示信息查询单个
  approveTipsQuery: {
    url: "/companyAttendance/approveTips/query",
    method: 'post',
    lodingState: false
  },
  //日考勤记录明细
  getRecordDetails: {
    url: "/companyAttendance/attendance/recordDetails",
    method: 'post',
    lodingState: true
  },
  //考勤报表(个人)不分页
  getReportOwner: {
    url: "/companyAttendance/attendance/reportOwner",
    method: 'post',
    lodingState: true
  },
  //打卡状态
  getDurationStatus: {
    url: "/companyAttendance/durationStatus/list",
    method: 'post',
    lodingState: false
  },
  //合同编号获取
  getContractCode: {
    url: "/project/getContractCode",
    method: 'get',
    lodingState: false
  },
  //合同编号获取
  contractOperatingRecordList: {
    url: "/project/contractOperatingRecordList",
    method: 'post',
    lodingState: true
  },
  // 无权限的部门树形结构
  getTreeDepartment: {
    url: "/company/getCompanyDepartmentTree",
    method: 'post',
    lodingState: true
  },
  // 查询当前当前企业自定义的工程等级
  customClass: {
    url: "/project/baseInfo/getCompanyProjectLevel",
    method: 'post',
    lodingState: true
  },
  // 添加新的自定义工程等级
  addCustomClass: {
    url: "/project/",
    urlEnd: "/baseInfo/updateProjectLevel",
    method: "post",
    lodingState: true
  },
  // 大屏项目统计
  countProjectData: {
    url: "/projectCount/countProjectData",
    method: 'post',
    lodingState: false
  },
  // 大屏企业证书统计
  countCompanyCertificate: {
    url: "/projectCount/countCompanyCertificate",
    method: 'post',
    lodingState: false
  },
  // 大屏人员证书统计
  countPersonCertificate: {
    url: "/projectCount/countPersonCertificate",
    method: 'post',
    lodingState: false
  },
  // 大屏所有在建合同统计
  getCountContract: {
    url: "/projectCount/countContract",
    method: 'post',
    lodingState: false
  },
  // 大屏企业人员统计
  enterprisePersonnel: {
    url: "/projectCount/enterprisePersonnel",
    method: 'post',
    lodingState: false
  },
  // 大屏项目文件统计
  projectFileCount: {
    url: "/projectCount/projectFileCount",
    method: 'post',
    lodingState: false
  },
  // 鼎信大屏项目总览
  projectOverview: {
    url: "/largeScreen/projectOverview",
    method: 'post',
    lodingState: false
  },
  // 鼎信大屏工程拨付款统计
  projectFundsCount: {
    url: "/largeScreen/projectFundsCount",
    method: 'post',
    lodingState: false
  },
  // 鼎信大屏智慧工地
  wisdomSite: {
    url: "/largeScreen/wisdomSite",
    method: 'post',
    lodingState: false
  },
  // 鼎信大屏项目合同
  getProjectContract: {
    url: "/largeScreen/projectContract",
    method: 'post',
    lodingState: false
  },
  // 贵州监管平台项目列表
  supervisoryPlatformList: {
    url: "/supervisoryPlatform/projectList",
    method: 'post',
    lodingState: false
  },
  // 贵州监管平台项目统计
  supervisoryPlatformCount: {
    url: "/supervisoryPlatform/projectCount",
    method: 'post',
    lodingState: false
  },
  // 贵州监管平台天气
  realTimeWeather: {
    url: "/supervisoryPlatform/realTimeWeather",
    method: 'post',
    lodingState: false
  },
  // 工单列表-监管方
  workOrder: {
    url: "/gsh/workOrder/supervisoryWorkOrderSupervision",
    method: 'post',
    lodingState: true
  },
  // 工单列表-项目方
  projectWorkOrder: {
    url: "/gsh/workOrder/",
    urlEnd: "/projectWorkOrderSupervision",
    method: "post",
    lodingState: true
  },
  // 责任单位
  workOrderOtherInfo: {
    url: "/gsh/workOrder/otherInfo",
    method: 'post',
    lodingState: false
  },
  // 工单说明新增
  supervisoryContentAdd: {
    url: "/gsh/workOrder/supervisoryContent/add",
    method: 'post',
    lodingState: false
  },
  // 工单说明修改
  supervisoryContentUpdate: {
    url: "/gsh/workOrder/supervisoryContent/update",
    method: 'post',
    lodingState: false
  },
  // 工单删除
  supervisoryContentDel: {
    url: "/gsh/workOrder/supervisoryContent/del",
    method: 'post',
    lodingState: true
  },
  // 工单配合单位
  personnelOfUnits: {
    url: "/gsh/workOrder/personnelOfUnits",
    method: 'post',
    lodingState: true
  },
  // 工单下发
  supervisoryCreate: {
    url: "/gsh/workOrder/create",
    method: 'post',
    lodingState: true
  },
  //工单详情
  workOrderDetail: {
    url: "/gsh/workOrder/workOrder/",
    urlEnd: "/",
    method: "post",
    lodingState: false
  },
  // 工单处理
  workOrderProcessing: {
    url: "/gsh/workOrder/processing",
    method: 'post',
    lodingState: true
  },

};



// WEBPACK FOOTER //
// ./src/api/publicConst.js